var map = {
	"./arts.jpg": 85,
	"./business.jpg": 86,
	"./comedy.jpg": 87,
	"./games.jpg": 88,
	"./health.jpg": 89,
	"./kids.jpg": 90,
	"./music.jpg": 91,
	"./news.jpg": 92,
	"./religion.jpg": 93,
	"./science.jpg": 94,
	"./society.jpg": 95,
	"./sports.jpg": 96,
	"./technology.jpg": 97,
	"./thumbnail.png": 34,
	"./tv.jpg": 98
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84;